import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { environment } from '../environments/environment.prod';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { Pipe } from '@angular/core';
import { HttpClient, HttpRequest, HttpHeaders } from '@angular/common/http';
import { Blog } from './components/model/blog';
import { isPlatformBrowser } from '@angular/common';
import { Video } from './components/model/video';

@Injectable({
  providedIn: 'root'
})
export class MainserviceService {

  constructor(private http: HttpClient, @Inject(PLATFORM_ID) private platformId: object) {
    this.hasConsented();
  }
  baseUrl: string = environment.backend.baseURL;
  baseResUrl: string = environment.backend.baseResUrl;
  paymentUrl: string = environment.backend.paymentUrl;

  hasConsented(): boolean {
    if (isPlatformBrowser(this.platformId)) {
      return localStorage.getItem('cookie_consent') === 'true';
    }
    return false;
  }

  getCountryList(): Observable<any> {
    return this.http.get(this.paymentUrl + 'getcountry/')
  }


    trackVisitor(pageVisited: string): void {
    this.http
      .post(this.baseResUrl+'/track', null, {
        params: { pageVisited },
      })
      .subscribe();
  }



  // getVisitorInfo() {
  //   const headers = new HttpHeaders({
  //     'User-Agent': navigator.userAgent,
  //     'Accept-Language': navigator.language,
  //     'Referer': document.referrer || document.location.href
  //   });

  //   this.http.post(`https://medeil.com/api/track?pageVisited=${encodeURIComponent(window.location.pathname)}`, {}, { headers })
  //     .subscribe({
  //       next: () => console.log("Visitor tracked."),
  //       error: (err) => console.error("Tracking failed", err)
  //     });
  // }




  // --dial code api--
  getMobileCode(data: any): Observable<any> {

    // var headerToken = {'Authorization': `Bearer `+ localStorage.getItem('token')};
    return this.http.get(this.baseResUrl + 'getCountrycode/' + data) //, {  headers: headerToken, responseType: 'json' }
  }

  //  apiUrl:any = 'http://localhost:8090';
  // // getip:any = '/savestudentdata';



  getIpAddress1(): Observable<any> {
    // return this.http.get('https://ipapi.co/json')
    if (isPlatformBrowser(this.platformId)) {
      return this.http.get('https://ipapi.co/json');
    } else {
      return null; // Return null for SSR to prevent errors
    }
  }
  getIpAddress() {
    return this.http.get('https://ipinfo.io/?token=9f091731b1cb99').pipe(tap((res: any) => { }));
  }
  getdailcode(ip: string): Observable<any> {
    return this.http.get("https://secure.medeil.io/medeilpospay/payment" + '/countryname2/' + ip)
  }
  captcha!: string
  generatecaptcha() {
    var characters = "ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz";
    var lenString = 7;
    var randomstring = '';

    for (var i = 0; i < lenString; i++) {
      var rnum = Math.floor(Math.random() * characters.length);
      randomstring += characters.substring(rnum, rnum + 1);
    }

    this.captcha = randomstring
    console.log("randomstring", randomstring);
    //  localStorage.setItem('captcha',this.captcha)
    if (isPlatformBrowser(this.platformId)) {
      localStorage.setItem('captcha', this.captcha);
    }
  }
  savelead(data: any) {
    return this.http.post(this.baseResUrl + 'saveleadlanding', data)
  }

  savemsg(data:any){
    return this.http.post(this.baseResUrl+'savecontactmessage', data)
  }//savecontactform

  gettimeSlots(data: any): Observable<any> {
    var headerToken = { 'Authorization': `Bearer ` + localStorage.getItem('token') };
    return this.http.post(this.baseResUrl + 'UTCTimezoneConverter', data, { headers: headerToken, responseType: 'json' });
  }
  savecomparison(data: any) {
    return this.http.post(this.baseResUrl + 'saveinterestlead', data)
  }

  private readonly consentKey = 'cookie_consent';

  // hasConsented(): boolean {
  //   return localStorage.getItem(this.consentKey) === 'true';
  // }

  setConsent(consent: boolean): void {
    localStorage.setItem(this.consentKey, consent.toString());
  }
  internData(data: any) {
    return this.http.post(this.baseResUrl + 'saveintendlead', data).pipe(tap((res) => {

    }))
  }

  // blog api
  viewAllBlogs() {
    const language = localStorage.getItem('selectedLanguage');
    return this.http.get(this.baseResUrl + 'viewAllBlogs/' + language).pipe(tap((res: any) => {

    }))

  }
  viewAllBlogs1() {
    const language = localStorage.getItem('selectedLanguage');
    return this.http.get(this.baseResUrl + 'viewAllBlogs/' + language).pipe(tap((res: any) => {

    }))

  }
  viewBlogsById(id: any) {
    return this.http.get(this.baseResUrl + '/viewBlogs' + '/' + id).pipe(tap((res: any) => { }))
  }
  viewBlogsBySlug(slug: any) {
    return this.http.get(this.baseResUrl + '/viewBlogsSlug' + '/' + slug).pipe(tap((res: any) => { }))
  }
  getPaginatedBlogs(currentPage: any, languageStatus: any, pageSize: any) {
    return this.http.get(this.baseResUrl + 'pagination' + '/' + currentPage + '/' + languageStatus + '/' + pageSize).pipe((tap((res: any) => {

    })))
  }
  saveBlog(blog: Blog) {
    return this.http.post(this.baseResUrl + 'saveBlogs', blog).pipe((tap((res: any) => {

    })))
  }
  deleteBlog(id: any) {
    return this.http.get(this.baseResUrl + 'deleteBlog' + '/' + id).pipe((tap((res: any) => {

    })))
  }
  addVideo(data: any) {
    return this.http.post(this.baseResUrl + 'save-video', data).pipe(tap((res: any) => {

    }))
  }
  getVideo() {
    return this.http.get(this.baseResUrl + 'view-video').pipe(tap((res: any) => {

    }))
  }
  deleteVideoByID(id: any) {
    return this.http.get(this.baseResUrl + 'update-video' + '/' + id).pipe(tap((res: any) => {

    }))
  }
  saveLandingPage(data: any) {
    return this.http.post(this.baseResUrl + 'save-landing-page', data)
    // .pipe(map((res:any)=>{

    // }))
  }
  viewLandingPage(): Observable<any> {
    return this.http.get(this.baseResUrl + 'get-landingpage-all')
    // .pipe(map((res:any)=>{

    // }))
  }

  getCountry(): Observable<any> {
    return this.http.get(this.baseResUrl + 'getCountryList').pipe(tap((response: any) => { }))
  }
  getState(countryID:any){
    return this.http.get(this.baseResUrl+'getStateList' + '/' + countryID).pipe(tap((response:any)=>{}))
  }
  getCity(stateID:any){
    return this.http.get(this.baseResUrl+'getCity' + '/' + stateID).pipe(tap((response:any)=>{}))
  }



}
